export const kycStatusesTypes = [
  'approved', // approved kyc
  'pending', // pending for admin review
  'reUploaded', // upload new document (unuploaded,pending,expired,rejected_by_admin)
  'partial', // partial rejected
  'rejectedByAdmin', // rejected whole kyc
  'rejectedByUser',
  'rejected_by_user',
  'expired', // expired one documents
  'denied', // old status for replacedByNewer
  'replacedByNewer', // replace with newer documents
  'unUploaded', // kyc dont exist
  'unCompleted', // missing document
] as const;
export const kycStatusesList = Array.from(kycStatusesTypes);
export type TKycStatus = typeof kycStatusesTypes[number];

export interface IKycStatus {
  status: TKycStatus;
  id?: string;
  approvedIdentity?: boolean;
  approvedAddress?: boolean;
  approvedSelfie?: boolean;
  documents?: any[];
  createdAt?: string;
  updatedAt?: string;
}

/**
 * Check if we can edit profile
 * @param status status of KYC
 * @returns if can
 */
export function canEditKyc(status?: TKycStatus) {
  if (!status) {
    return true;
  }

  return status === 'unCompleted' || status === 'unUploaded';
}

/**
 * Check if we should change info in KYC
 * @param status status
 * @returns if we need re upload
 */
export function kycNeedChange(status?: TKycStatus) {
  if (!status) {
    return false;
  }

  return status === 'rejectedByAdmin';
}

/**
 * Check user has approved KYC
 * @param status status
 * @returns if we need re upload
 */
export function isKycApproved(status?: TKycStatus) {
  return status === 'approved';
}

/**
 * Check if kyc is pending
 * @param status status
 * @returns if kyc is pending
 */
export function isKycPending(status?: TKycStatus) {
  return status === 'pending';
}
